import { Play } from '@core/assets/Play';
import { useContextTranslation } from '@core/i18n';
import { LIVESTREAM_ENTER_STREAM_CTA } from '@player/testIds';
import { useThumbnailOnClick } from '../useThumbnailOnClick';
import { CTAWrapper, LivestreamCTA } from './PlayerDeckContainer.styles';
/**
 *
 * @param param0
 * @returns
 */
export const PlayerDeckLivestreamCTA = ({ video, params, appContext, }) => {
    const { t } = useContextTranslation();
    const { onThumbnailClick } = useThumbnailOnClick({
        video,
        params,
        appContext,
    });
    return (<CTAWrapper>
      <LivestreamCTA onClick={onThumbnailClick} data-testid={LIVESTREAM_ENTER_STREAM_CTA}>
        {t('Tap to Watch')}
        <div style={{ height: '32px', width: '32px' }}>
          <Play label="" aria-hidden circle={false}/>
        </div>
      </LivestreamCTA>
    </CTAWrapper>);
};
